export type TMobileState = {
    mobileAppPath: string | null
    platform: 'Android' | 'iOS' | 'Web' | null
    showReturnToMobileModal: boolean
    hasArrivedFromMobile: boolean
    productIndex: number | null
    priorScreenName: string | null
}

export const getInitialMobileState = (): TMobileState => {
    return {
        hasArrivedFromMobile: false,
        mobileAppPath: null,
        showReturnToMobileModal: false,
        platform: null,
        productIndex: null,
        priorScreenName: null,
    }
}

const moduleState = getInitialMobileState()

export default moduleState
